export const UXP_CLOSE_EMBEDDED_MEDIA_VIEWER = 'close-embedded-media-viewer';
export const UXP_SYNC_PREMIERE_PLAYHEAD = 'sync-premiere-playhead';
export const UXP_ADD_PREMIERE_MARKER = 'add-premiere-marker';

export type UxpPremiereSyncAssetId = { assetId: string };

export function isEmbeddedMediaViewerPathname(pathname: string): boolean {
  return pathname === '/media-viewer' || pathname.startsWith('/media-viewer/');
}

export function mediaViewerPath(
  assetId: string,
  versionId: string,
  search: string
) {
  return { pathname: `/media-viewer/${assetId}/${versionId}`, search };
}

export function closeEmbeddedMediaViewer(options?: { assetId?: string }) {
  const { uxpHost } = window as unknown as {
    uxpHost?: { postMessage: (msg: object) => void };
  };
  if (uxpHost) {
    uxpHost.postMessage({
      type: UXP_CLOSE_EMBEDDED_MEDIA_VIEWER,
      ...(options?.assetId ? { assetId: options.assetId } : {})
    });
    return true;
  }
  return false;
}
